import TravelClassSeatCountInterface from '../../interfaces/client/TravelClassSeatCount'

export default (travelClassSeatCounts: TravelClassSeatCountInterface[]) =>
  travelClassSeatCounts.reduce(
    (total: number, travelClassSeatCounts: TravelClassSeatCountInterface) =>
      total + travelClassSeatCounts.availableAmountOfSeats,
    0
  )
